const CloudUserFormatter = ({ value }) => {
    return value ? value.username.toUpperCase() : '';
};

export default CloudUserFormatter;
